import { render, staticRenderFns } from "./BaseRespondsCounter.vue?vue&type=template&id=544f8a78"
import script from "./BaseRespondsCounter.vue?vue&type=script&lang=ts"
export * from "./BaseRespondsCounter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports